/*
  Halfwild – Korrekturen am Warenkorb, die sich über den Theme-Editor
  nicht einstellen lassen.

  1. Entfernen funktioniert auch auf der Warenkorb-Seite.
     Die Schublade und die Seite /cart rendern beide eigene Entfernen-Knöpfe.
     Die der Seite tragen nur eine Zeilennummer (data-index) und keinen Key.
     Verschiebt sich der Warenkorb, zeigt die Nummer ins Leere und Shopify
     antwortet mit "Parameter ungültig" – der Knopf tut dann gar nichts mehr.
     Wir arbeiten deshalb überall mit dem Line-Item-Key.

  2. Schublade geht nach dem Hinzufügen auf.
     Shrine ist auf "drawer" gestellt, ruft open() aber nicht auf.

  3. Nicht verdiente Geschenke fliegen raus.
     Die Geschenke hängen an der Menge der Kühlmatte.

  4. Versandschutz lässt sich wieder abschalten.
     Shrines Schalter hielt seinen Zustand nicht mit dem Warenkorb synchron.
*/
(function () {
  'use strict';

  var MAIN_HANDLE = 'kuehlmatte';

  // Geschenk-Handle → ab welcher Menge der Hauptware es zusteht
  var GIFTS = {
    'geschenk-gratis-versand': 2,
    'geschenk-telegram-community': 2,
    'geschenk-sommer-guide-ebook': 3,
    'geschenk-kuehlbandana': 3,
  };

  var busy = false;
  var letzterWarenkorb = null;   // Momentaufnahme, um Zeilennummern in Keys zu übersetzen

  function istWarenkorbSeite() {
    return /^\/cart\/?$/.test(window.location.pathname);
  }

  function cartItemFor(node) {
    return node.closest('.cart-item, .cart-drawer-item');
  }

  function warenkorbLesen() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { letzterWarenkorb = cart; return cart; });
  }

  // --- Position entfernen ------------------------------------------------
  /* Entfernt genau die angeklickte Position über ihren Line-Item-Key.

     Über den Produkt-Handle ging es nicht: liegen XS, S und M derselben Matte
     im Warenkorb, haben alle drei denselben Handle, und es flog immer die
     oberste Zeile raus statt der angeklickten. Über die Zeilennummer ging es
     auch nicht – die veraltet. Der Key ist pro Zeile eindeutig und stabil. */
  function entfernen(key, link) {
    if (!key) return Promise.resolve();
    if (link) { link.disabled = true; link.textContent = 'Wird entfernt …'; }

    // Wir kümmern uns unten selbst um Geschenke und Neuzeichnen. Ohne diese
    // Markierung liefe zusätzlich die allgemeine Runde an – doppelte Arbeit
    // und ein zweites, sichtbares Neuaufbauen der Schublade.
    eigenerZugriff = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then(function () { return syncGifts(); })
      .then(function () { return neuZeichnen(); })
      .catch(function () {
        if (link) { link.disabled = false; link.textContent = 'Entfernen'; }
      });
  }

  /* Findet den Key zu einer Zeile.
     Erst am Element (Schublade), sonst über die Zeilennummer aus der
     Momentaufnahme, die direkt vor dem Zeichnen geholt wurde. */
  function keyFuerZeile(native) {
    if (native.dataset.key) return native.dataset.key;

    var nummer = parseInt(native.dataset.index, 10);
    if (letzterWarenkorb && nummer >= 1 && letzterWarenkorb.items[nummer - 1]) {
      return letzterWarenkorb.items[nummer - 1].key;
    }
    return null;
  }

  function addRemoveLinks(root) {
    var items = (root || document).querySelectorAll('.cart-drawer-item, .cart-item');
    Array.prototype.forEach.call(items, function (item) {
      if (item.querySelector('.hw-remove-link')) return;
      var native = item.querySelector('cart-remove-button');
      if (!native) return;

      var key = keyFuerZeile(native);
      if (!key) return;

      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'hw-remove-link';
      link.textContent = 'Entfernen';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        entfernen(key, link);
      });

      var host =
        item.querySelector('.cart-drawer-item__right') ||
        item.querySelector('.cart-item__details') ||
        item;
      host.appendChild(link);
    });
  }

  // --- Neu zeichnen ------------------------------------------------------
  // Die Knöpfe und Mengenfelder des Themes arbeiten mit Zeilennummern.
  // Ändert sich der Warenkorb, ohne dass neu gezeichnet wird, zeigen sie auf
  // Zeilen, die es nicht mehr gibt – ab dann reagiert kein Knopf mehr.
  // Auf /cart müssen dieselben Abschnitte mit, sonst sieht der Kunde auf der
  // Seite noch den alten Stand (der Versandschutz "verschwand" dort nicht).
  // Läuft schon eins, wird das nächste nicht verworfen, sondern hinterher
  // nachgeholt. Vorher fiel es aus: Wer zweimal schnell auf Minus drückt,
  // sah danach den Stand von vor dem zweiten Klick – und der nächste Klick
  // traf eine Zeile, die es so nicht mehr gab.
  var rendering = false;
  var nochmalZeichnen = false;
  function neuZeichnen() {
    if (rendering) { nochmalZeichnen = true; return Promise.resolve(); }
    rendering = true;

    var abschnitte = istWarenkorbSeite()
      ? 'main-cart-items,main-cart-footer,cart-drawer,cart-icon-bubble'
      : 'cart-drawer,cart-icon-bubble';

    // Warenkorb und Abschnitte gleichzeitig holen statt nacheinander –
    // hintereinander kostete das eine volle Antwortzeit extra.
    return Promise.all([
      warenkorbLesen(),
      fetch('/?sections=' + abschnitte, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }),
    ])
      .then(function (beides) { return beides[1]; })
      .then(function (data) {
        var parser = new DOMParser();

        function ersetzen(name, wahl) {
          if (!data[name]) return;
          var frisch = parser.parseFromString(data[name], 'text/html').querySelector(wahl);
          var aktuell = document.querySelector(wahl);
          if (frisch && aktuell) aktuell.innerHTML = frisch.innerHTML;
        }

        var drawer = document.querySelector('cart-drawer');
        var warOffen = drawer && drawer.classList.contains('active');
        ersetzen('cart-drawer', 'cart-drawer');
        if (warOffen && drawer) drawer.classList.add('active');

        ersetzen('cart-icon-bubble', '#cart-icon-bubble');
        ersetzen('main-cart-items', '.cart-items, cart-items');
        ersetzen('main-cart-footer', '.cart__footer, #main-cart-footer');

        addRemoveLinks(document);
        addTrustBar(document.querySelector('cart-drawer'));
        upsellStandAngleichen(document, letzterWarenkorb);
      })
      .catch(function () { /* Zeichnen fehlgeschlagen – Anzeige bleibt wie sie ist */ })
      .then(function () {
        rendering = false;
        if (nochmalZeichnen) { nochmalZeichnen = false; return neuZeichnen(); }
      });
  }

  // --- Schublade öffnen --------------------------------------------------
  // Das Theme steht auf "drawer", ruft open() nach dem Hinzufügen aber nicht
  // auf. Der Kunde legt etwas in den Warenkorb und sieht keinerlei Reaktion.
  function schubladeOeffnen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      try { drawer.open(); } catch (e) { /* fällt unten durch */ }
    }
    if (!drawer.classList.contains('active')) {
      drawer.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
  }

  // --- Versandhinweis unten in der Schublade -----------------------------
  function addTrustBar(root) {
    var drawer = root || document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.querySelector('.hw-cart-trust')) return;

    var footer =
      drawer.querySelector('.cart-drawer__footer') ||
      drawer.querySelector('.drawer__footer');
    if (!footer) return;

    var bar = document.createElement('div');
    bar.className = 'hw-cart-trust';
    bar.innerHTML =
      '<span><span class="material-symbols-outlined">local_shipping</span>Gratis ab 100 €</span>' +
      '<span><span class="material-symbols-outlined">undo</span>14 Tage Widerruf</span>' +
      '<span><span class="material-symbols-outlined">lock</span>Sicher bezahlen</span>';

    footer.insertBefore(bar, footer.firstChild);
  }

  // --- Versandschutz-Schalter --------------------------------------------
  // Shrines Schalter hält seinen Zustand (data-selected) nicht mit dem
  // Warenkorb synchron: Der Versandschutz lag drin und wurde berechnet,
  // während der Schalter auf "aus" stand – ausschalten ging damit nicht mehr.
  function upsellStandAngleichen(root, bekannterKorb) {
    var schalter = (root || document).querySelectorAll('cart-drawer-upsell[data-handle]');
    if (!schalter.length) return Promise.resolve();

    // Liegt der Warenkorb schon vor, nicht noch einmal holen. Jeder
    // zusätzliche Aufruf verzögert die Anzeige sichtbar.
    return (bekannterKorb ? Promise.resolve(bekannterKorb) : warenkorbLesen())
      .then(function (cart) {
        Array.prototype.forEach.call(schalter, function (el) {
          var drin = cart.items.some(function (i) { return i.handle === el.dataset.handle; });
          el.dataset.selected = drin ? 'true' : 'false';
          el.classList.toggle('upsell--selected', drin);
        });
      })
      .catch(function () { /* Anzeige bleibt wie sie ist */ });
  }

  // Klicksperre: Der Schalter entscheidet anhand des gelesenen Warenkorbs.
  // Zwei schnelle Klicks lesen beide "liegt nicht drin" und legen den
  // Versandschutz zweimal hinein – der Kunde zahlt ihn doppelt. Solange ein
  // Umschalten läuft, werden weitere Klicks verworfen.
  var upsellLaeuft = false;

  document.addEventListener(
    'click',
    function (event) {
      var knopf = event.target.closest('.upsell-toggle-btn, .upsell__toggle-switch');
      if (!knopf) return;

      var el = knopf.closest('cart-drawer-upsell[data-handle]');
      if (!el || !el.dataset.id) return;

      event.preventDefault();
      event.stopPropagation();

      if (upsellLaeuft) return;
      upsellLaeuft = true;

      var handle = el.dataset.handle;
      var variantenId = el.dataset.id;

      warenkorbLesen()
        .then(function (cart) {
          var zeile = cart.items.filter(function (i) { return i.handle === handle; })[0];

          // Der Versandschutz berührt keine Geschenkstufe – die allgemeine
          // Runde hätte hier nichts zu tun und würde nur ein zweites Mal
          // zeichnen. Deshalb als eigener Zugriff markiert.
          eigenerZugriff = true;

          if (zeile) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: zeile.key, quantity: 0 }),
            });
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantenId), quantity: 1 }] }),
          });
        })
        .then(function () { return neuZeichnen(); })
        .catch(function () { /* Anzeige bleibt wie sie ist */ })
        .then(function () { upsellLaeuft = false; });
    },
    true
  );

  var drawerObserver = null;
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawerObserver) return;
    addRemoveLinks(document);
    addTrustBar(drawer);
    upsellStandAngleichen(document);
    drawerObserver = new MutationObserver(function () {
      addRemoveLinks(document);
      addTrustBar(drawer);
    });
    drawerObserver.observe(drawer, { childList: true, subtree: true });
  }

  // --- Minus bei Menge 1 entfernt die Position ---------------------------
  document.addEventListener(
    'click',
    function (event) {
      var minus = event.target.closest('button[name="minus"]');
      if (!minus) return;

      var item = cartItemFor(minus);
      if (!item) return;

      var input = item.querySelector('input[name="updates[]"], .quantity__input');
      if (!input || parseInt(input.value, 10) !== 1) return;

      var native = item.querySelector('cart-remove-button');
      if (!native) return;
      var key = keyFuerZeile(native);
      if (!key) return;

      // Gegenprobe am Warenkorb. Das Mengenfeld im Bild kann veraltet sein,
      // wenn kurz zuvor schon einmal geklickt wurde – dann stünde hier eine 1,
      // während die Zeile in Wahrheit noch bei 2 liegt. Ohne die Gegenprobe
      // flöge die ganze Position raus statt einer Einheit.
      if (letzterWarenkorb) {
        var zeile = letzterWarenkorb.items.filter(function (i) { return i.key === key; })[0];
        if (zeile && zeile.quantity !== 1) return;
      }

      event.preventDefault();
      event.stopPropagation();
      entfernen(key, null);
    },
    true
  );

  // --- Paket mit verschiedenen Größen ------------------------------------
  /* Beim 2er- und 3er-Paket zeigt das Theme je Position ein eigenes
     Größen-Auswahlfeld (#1, #2, #3). Abgeschickt wird beim Hinzufügen aber
     nur die oberste Variante mit Menge N: Wer XS, L und XL wählt, bekommt
     dreimal XS. Der Kunde merkt es erst, wenn das Paket ankommt.

     Grund: Die Auswahlfelder liegen außerhalb des Produktformulars und
     landen deshalb nie im abgeschickten Datensatz.

     Wir greifen den Klick ab und legen die Positionen einzeln in den
     Warenkorb. Der Paketpreis bleibt: Die Rabatte hängen an der
     Zwischensumme (ab 129,80 € bzw. 194,70 €), nicht an einer bestimmten
     Variante – drei Matten ergeben in jeder Größenkombination denselben
     Betrag. Sind alle Positionen gleich groß, lassen wir das Theme
     unangetastet seinen eigenen Weg gehen. */
  var variantenKarte = null;
  function variantenLesen() {
    if (variantenKarte) return Promise.resolve(variantenKarte);
    return fetch('/products/' + MAIN_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (produkt) {
        variantenKarte = {};
        produkt.variants.forEach(function (v) { variantenKarte[v.title] = v.id; });
        return variantenKarte;
      });
  }

  /* Liefert die gewählten Größen, wenn sie sich unterscheiden – sonst null. */
  function paketGroessen(form) {
    // Menge und Größe hängen über das form-Attribut am Formular, liegen aber
    // nicht darin. Ein querySelector im Formular findet sie deshalb nicht –
    // FormData schon, und das ist ohnehin genau das, was abgeschickt würde.
    var menge = parseInt(new FormData(form).get('quantity'), 10) || 1;
    if (!menge || menge < 2) return null;

    // Das gewählte Paket erkennen wir an der Zahl seiner Positionen.
    var wrapper = Array.prototype.filter.call(
      document.querySelectorAll('.quantity-break__wrapper'),
      function (w) { return w.querySelectorAll('.quantity-break__selector-item').length === menge; }
    )[0];
    if (!wrapper) return null;

    var groessen = Array.prototype.map.call(
      wrapper.querySelectorAll('.quantity-break__selector-item'),
      function (slot) {
        var feld = slot.querySelector('select.quantity-break__variant-select');
        return feld ? feld.value : null;
      }
    );
    if (groessen.length !== menge) return null;
    if (groessen.some(function (g) { return !g; })) return null;

    /* Auch wenn alle Positionen dieselbe Größe haben, übernehmen wir.
       Test: drei Felder auf M gestellt – das Theme legte trotzdem 3× XS
       (die oberste Variante) in den Warenkorb. Die Auswahlfelder werden
       also generell nicht ausgewertet, nicht nur bei gemischten Größen. */
    return groessen;
  }

  document.addEventListener(
    'click',
    function (event) {
      var knopf = event.target.closest('button[name="add"]');
      if (!knopf) return;

      var form = knopf.closest('form[action*="/cart/add"]');
      if (!form) return;

      var groessen = paketGroessen(form);
      if (!groessen) return;   // gleiche Größen – das kann das Theme selbst

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var beschriftung = knopf.textContent;
      knopf.disabled = true;

      variantenLesen()
        .then(function (karte) {
          var posten = groessen
            .map(function (g) { return { id: karte[g], quantity: 1 }; })
            .filter(function (eintrag) { return eintrag.id; });

          if (posten.length !== groessen.length) {
            throw new Error('Zu mindestens einer Größe fehlt die Variante');
          }

          eigenerZugriff = true;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: posten }),
          });
        })
        .then(function () { return syncGifts(); })
        .then(function () { return neuZeichnen(); })
        .then(function () { schubladeOeffnen(); })
        .catch(function () {
          // Im Zweifel nichts verschlucken: Formular normal abschicken.
          eigenerZugriff = false;
          form.submit();
        })
        .then(function () {
          knopf.disabled = false;
          knopf.textContent = beschriftung;
        });
    },
    true
  );

  // --- Verwaiste Geschenke entfernen -------------------------------------
  /* Wer die Menge zweimal schnell runterdrückt (3 → 2 → 1), löste zwei
     Prüfungen aus. Die zweite fiel in die Sperre der ersten und wurde
     verworfen – am Ende lag eine Matte im Warenkorb, aber der Gratis-Versand
     und der Telegram-Zugang aus der 2er-Stufe lagen noch dabei.
     Jetzt wird eine Prüfung, die in die Sperre läuft, hinterher nachgeholt. */
  var giftNochmal = false;
  var eigenerZugriff = false;   // markiert unseren eigenen Schreibzugriff

  /* Liefert zurück, ob tatsächlich etwas am Warenkorb geändert wurde.
     Daran hängt, ob danach überhaupt neu gezeichnet werden muss – in den
     allermeisten Fällen stimmen die Geschenke längst, und ein zweiter
     Neuaufbau der Schublade wäre nur sichtbares Zucken. */
  function syncGifts() {
    if (busy) { giftNochmal = true; return Promise.resolve(false); }
    busy = true;

    return geschenkeDurchgehen()
      .catch(function () { return false; })   // Warenkorb nicht lesbar – dann eben nicht
      .then(function (veraendert) {
        busy = false;
        if (giftNochmal) {
          giftNochmal = false;
          return syncGifts().then(function (auch) { return veraendert || auch; });
        }
        return veraendert;
      });
  }

  function geschenkeDurchgehen() {
    return warenkorbLesen()
      .then(function (cart) {
        var mainQty = 0;
        cart.items.forEach(function (item) {
          if (item.handle === MAIN_HANDLE) mainQty += item.quantity;
        });

        var updates = {};
        cart.items.forEach(function (item) {
          var required = GIFTS[item.handle];
          if (required === undefined) return;
          if (mainQty < required) {
            updates[item.key] = 0;            // nicht verdient → raus
          } else if (item.quantity > 1) {
            updates[item.key] = 1;            // je Geschenk genau eins
          }
        });

        /* Verdiente, aber fehlende Geschenke nachlegen.
           Nötig, seit wir Pakete mit gemischten Größen selbst in den Warenkorb
           legen: Das Theme hängt seine Geschenke nur an sein eigenes
           Hinzufügen, unseren Weg kennt es nicht. Ohne das ginge der Kunde
           beim gemischten 3er-Paket ohne Guide und Community raus. */
        var fehlend = Object.keys(GIFTS).filter(function (handle) {
          if (mainQty < GIFTS[handle]) return false;
          return !cart.items.some(function (i) { return i.handle === handle; });
        });

        if (!Object.keys(updates).length && !fehlend.length) return false;

        var schritte = Promise.resolve();

        if (Object.keys(updates).length) {
          schritte = schritte.then(function () {
            eigenerZugriff = true;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates }),
            });
          });
        }

        if (fehlend.length) {
          schritte = schritte
            .then(function () {
              return Promise.all(fehlend.map(function (handle) {
                return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
                  .then(function (r) { return r.ok ? r.json() : null; })
                  .then(function (pr) { return pr && pr.variants && pr.variants[0] ? pr.variants[0].id : null; })
                  .catch(function () { return null; });
              }));
            })
            .then(function (ids) {
              var posten = ids
                .filter(Boolean)
                .map(function (id) { return { id: id, quantity: 1 }; });
              if (!posten.length) return null;
              eigenerZugriff = true;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: posten }),
              });
            });
        }

        return schritte
          .then(function () { return warenkorbLesen(); })
          .then(function () { return true; })
          .catch(function () { eigenerZugriff = false; return false; });
      });
  }

  // Nach jeder Warenkorb-Änderung prüfen. Die Themes melden das nicht
  // einheitlich, deshalb hängen wir uns an fetch statt an ein Event.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var istSchreibzugriff = /\/cart\/(add|change|update|clear)/.test(href);
    var istHinzufuegen = /\/cart\/add/.test(href);

    return originalFetch.apply(this, arguments).then(function (response) {
      // Unsere eigene Geschenk-Korrektur löst keine neue Runde aus. Sonst
      // liefe nach jeder Korrektur noch ein kompletter Durchlauf mit
      // zweitem Neuaufbau der Schublade – das war das Zucken und ein
      // guter Teil der Wartezeit.
      if (istSchreibzugriff && eigenerZugriff) { eigenerZugriff = false; return response; }

      // Sonst ohne Ausnahme prüfen. Früher stand hier "nur wenn gerade
      // nichts läuft" – genau die Änderung, die während einer laufenden
      // Prüfung ankam, fiel damit unter den Tisch.
      if (istSchreibzugriff) {
        setTimeout(function () {
          syncGifts().then(function (veraendert) {
            if (istHinzufuegen && !istWarenkorbSeite()) {
              return neuZeichnen().then(schubladeOeffnen);
            }
            // Nur neu zeichnen, wenn wir wirklich etwas geändert haben.
            // Hat sich nichts geändert, hat das Theme seine Ansicht längst
            // selbst erneuert – dann reicht es, unsere eigenen Ergänzungen
            // nachzuziehen. Das spart eine volle Runde pro Klick.
            if (veraendert) return neuZeichnen();

            addRemoveLinks(document);
            addTrustBar(document.querySelector('cart-drawer'));
            return upsellStandAngleichen(document, letzterWarenkorb);
          });
        }, 120);
      }
      return response;
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    warenkorbLesen().then(function () {
      watchDrawer();
      addRemoveLinks(document);
      return syncGifts();
    });
  });
  warenkorbLesen().then(function () { watchDrawer(); addRemoveLinks(document); });
})();
